<div class="grid">
  <div class="col-12">
    <span class="section-title" translate>payment_detail_references_label</span>
  </div>
  <!-- BOOKINGS -->
  @if (bookings) {
  <div class="col-12">
    @for (booking of bookings; track booking) {
    <div>
      @if (editMode) {
      <div class="grid">
        <div class="col-4"><label>{{ 'payment_detail_booking_ref_label' | translate }}:</label></div>
        <div class="col-4"><label>{{ 'payment_detail_check_in_label' | translate }}:</label></div>
        <div class="col-4"><label>{{ 'payment_detail_check_out_label' | translate }}:</label></div>
        <div class="col-4 field-value">{{ booking.reference }}</div>
        <div class="col-4">
          <p-datepicker id="checkinDate" dateFormat="{{getDateFormatForCalendar()}}" dateFormat="yy-mm-dd"
            [(ngModel)]="booking.checkinDate" appendTo="body" />
        </div>
        <div class="col-4">
          <p-datepicker id="checkoutDate" dateFormat="{{getDateFormatForCalendar()}}" dateFormat="yy-mm-dd"
            [(ngModel)]="booking.checkoutDate" appendTo="body" />
        </div>
        <!-- GUESTS -->
        <div class="col-12 mt-5 mb-3"><label>{{ 'payment_detail_pax_leader_label' | translate }}:</label></div>
        @for (guest of booking.guests; track guest) {
        <div class="grid col-12">
          <div class="col-4">
            <p-floatlabel>
              <input id="titleInput" type="text" pInputText [(ngModel)]="guest.title" />
              <label htmlFor="titleInput">{{ 'payment_detail_pax_leader_title_label' | translate }}:</label>
            </p-floatlabel>
          </div>
          <div class="col-4">
            <p-floatlabel>
              <input id="firstNameInput" type="text" pInputText [(ngModel)]="guest.firstName" />
              <label htmlFor="FirstName">{{ 'payment_detail_pax_leader_first_name_label' | translate }}:</label>
            </p-floatlabel>
          </div>
          <div class="col-4">
            <p-floatlabel>
              <input id="lastNameInput" type="text" pInputText [(ngModel)]="guest.lastName" />
              <label htmlFor="LastName">{{ 'payment_detail_pax_leader_last_name_label' | translate }}:</label>
            </p-floatlabel>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="grid" id="bookingInfo">
        <div class="col-3"><label>{{ 'payment_detail_booking_ref_label' | translate }}:</label></div>
        <div class="col-3"><label>{{ 'payment_detail_check_in_label' | translate }}:</label></div>
        <div class="col-3"><label>{{ 'payment_detail_check_out_label' | translate }}:</label></div>
        <div class="col-3"><label>{{ 'payment_detail_pax_leader_label' | translate }}:</label></div>
        <div class="col-3 field-value">{{ booking.reference }}</div>
        <div class="col-3 field-value">{{ booking.checkinDate! | customFormatDate }}</div>
        <div class="col-3 field-value">{{ booking.checkoutDate! | customFormatDate }}</div>
        <div class="col-3 field-value booking-guests">{{ bookingGuest(booking) }}</div>
      </div>
      }
    </div>
    }
  </div>
  }
  <!-- INVOICES -->
  @if (invoices) {
  <div class="col-12 mt-4">
    <div class="grid">
      <div class="col-3"><label>{{ 'payment_detail_invoice_ref_label' | translate }}:</label></div>
      <div class="col-3"><label>{{ 'payment_detail_invoice_date_label' | translate }}:</label></div>
    </div>
    @for (invoice of invoices; track invoice) {
    <div class="grid invoce-container">
      <div class="col-3 field-value">{{ invoice.reference }}</div>
      <div class="col-3 field-value">{{ invoice.date! | customFormatDate }}</div>
    </div>
    }
  </div>
  }
</div>